export const removeSnackbar = (snackbars, { id }) => {
  return snackbars.filter(({ id: snackbarId }) => id !== snackbarId);
};

export default removeSnackbar;
